import http from '../utils/http';

export const getEmails = () => http.get('/emailing/list');

export const sendEmail = (data) => http.post('/emailing', data);
